export default {
  required: value => !!value || 'Данное поле обязательно для заполнения!',
  min: (value, min) => value.length >= min || 'Минимум ' + min + ' символов',
  max: (value, max) => value.length <= max || 'Максимум ' + max + ' символов',
  email: value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || 'Не правильно введен e-mail'
  }
}
